// @flow

import type { IncomingPayment } from './types';
import type { FawryInfo } from '@tectonics/prs/incoming-payment/payment-option';

function getFawryInfo(incomingPayment: IncomingPayment): ?FawryInfo {
  return incomingPayment['fawry'];
}

export function getSafeFawryInfo(incomingPayment: IncomingPayment): FawryInfo {
  const fawry = getFawryInfo(incomingPayment);

  if (!fawry)
    throw new Error('ExternalPayProvider: no external pay provider in incoming payment');

  return fawry;
}
